import Analogs from './Analogs'
export default Analogs
